export var SpatialEntityComponentType;
(function (SpatialEntityComponentType) {
    SpatialEntityComponentType["Locatable"] = "locatable";
    SpatialEntityComponentType["Bounded3D"] = "bounded3D";
    SpatialEntityComponentType["Bounded2D"] = "bounded2D";
    SpatialEntityComponentType["TriangleMesh"] = "triangleMesh";
    SpatialEntityComponentType["SemanticLabel"] = "semanticLabel";
})(SpatialEntityComponentType || (SpatialEntityComponentType = {}));
export class SpatialEntityComponent extends EventTarget {
    constructor(_spatialEntity) {
        super();
        this._spatialEntity = _spatialEntity;
    }
}
//# sourceMappingURL=component.js.map